const formatCurrency = (value: number | string, currency: string, locale: string = 'en-US'): string => {
  const num = Number(value);
  if (!isNaN(num))  value;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

export default formatCurrency;
